import HorizontalWebinar from "../pages/Webinar/Horizontal";
import YouTubeFirstSlideWebinar from "../pages/Webinar/YouTubeFirstSlide";
import YouTubeThumbnailWebinar from "../pages/Webinar/YouTubeThumbnail";
import BlogSocialShareWebinar from "../pages/Webinar/BlogSocialShare";
import BlogFeaturedWebinar from "../pages/Webinar/BlogFeatured";
import StreamYardWebinar from "../pages/Webinar/StreamYard";
import StreamYardBackgroundWebinar from "../pages/Webinar/StreamYardBackground";
import EmailPhotoWebinar from "../pages/Webinar/EmailPhoto";
import SpeakerPhotoWebinar from "../pages/Webinar/SpeakerPhoto";
import InstagramStories from "../pages/Social/InstagramStories";
import YouTubeCommunity from "../pages/Social/YouTubeCommunity";
import InstagramFeed from "../pages/Social/InstagramFeed";
import SoMeVertical from "../pages/Social/SoMeVertical";
import LivestreamHorizontal from "../pages/Livestream/LivestreamHorizontal";
import LivestreamSquare from "../pages/Livestream/LivestreamSquare";
import LivestreamBlog from "../pages/Livestream/LivestreamBlog";
import LivestreamWide from "../pages/Livestream/LivestreamWide";
import LivestreamStories from "../pages/Livestream/LivestreamStories";
import LivestreamStoriesIntro from "../pages/Livestream/LivestreamStoriesIntro";
import LivestreamEmail from "../pages/Livestream/LivestreamEmail";
import Twitter from "../pages/Social/Twitter";
import Email01 from "../pages/Email/Email01";
import Email02 from "../pages/Email/Email02";
import Email03 from "../pages/Email/Email03";
import Email04 from "../pages/Email/Email04";
import Voucher from "../pages/Print/Voucher";
import YouTubeThumbnail from "../pages/Video/YouTubeThumbnail";
import BlogFeatured from "../pages/Social/BlogFeatured";
import BlogSocialShare from "../pages/Social/BlogSocialShare";
import BlogSocialShareInternal from "../pages/Internal/BlogSocialShare";
import LandingPage from "../pages/LandingPage/SitePreview";
import TwitterPartners from "../pages/Partners/Twitter";
import InstagramPostPartners from "../pages/Partners/InstagramPost";
import InstagramStoriesPartners from "../pages/Partners/InstagramStories";
import SoMeVerticalPartners from "../pages/Partners/SoMeVertical";
import InstagramFeedPartners from "../pages/Partners/InstagramFeed";
import QRcodeIPad from "../pages/Events/QRcodeIpad";
import QRcodeFullHD from "../pages/Events/QRcodeFullHD";
import QRcodeA4 from "../pages/Events/QRcodeA4";
import QRcodePrint from "../pages/Events/QRcodePrint";
import Splash from "../pages/Releases/Splash";
import Splash2x from "../pages/Releases/Splash2x";
import Splash2026 from "../pages/Releases/Splash2026";
import Splash2x2026 from "../pages/Releases/Splash2x2026";
import ReleasesEmail02 from "../pages/Releases/Email02";
import ReleasesEmail03 from "../pages/Releases/Email03";
import ReleasesEmail01 from "../pages/Releases/Email01";
import ReleasesEmail04 from "../pages/Releases/Email04";
import WebpagePreview from "../pages/Releases/WebpagePreview";
import HorizontalFeatures from "../pages/Releases/HorizontalFeatures";
import Wallpaper1 from "../pages/Releases/Wallpaper1";
import Wallpaper2 from "../pages/Releases/Wallpaper2";
import Wallpaper3 from "../pages/Releases/Wallpaper3";
import WallpaperPreview from "../pages/Releases/WallpaperPreview";
import DotNetSplash from "../pages/Releases/DotNetSplash";
import DotNetSplash2x from "../pages/Releases/DotNetSplash2x";
import DotNetSplashLegacy from "../pages/Releases/DotNetSplashLegacy";
import DotNetSplash2xLegacy from "../pages/Releases/DotNetSplash2xLegacy";
import Screenshot from "../pages/Releases/Screenshot";
import DemoVideoIntro from "../pages/Releases/DemoVideo/DemoVideoIntro";
import DemoVideoIntroDemo from "../pages/Releases/DemoVideo/DemoVideoIntroDemo";
import DemoVideoDemo from "../pages/Releases/DemoVideo/DemoVideoDemo";
import DemoVideoCode from "../pages/Releases/DemoVideo/DemoVideoCode";
import WhatsNewPreview from "../pages/Releases/WhatsNewPreview";
import TemplateScope from "../layout/TemplateScope";
import SoMeHorizontalAds from "../pages/Ads/SoMeHorizontalAds";
import InstagramPostAds from "../pages/Ads/InstagramPostAds";
import InstagramStoriesAds from "../pages/Ads/InstagramStoriesAds";
import RedditAds from "../pages/Ads/RedditAds";
import DailyDevAds from "../pages/Ads/DailyDevAds";
import RedditThumb1Ads from "../pages/Ads/RedditThumb1Ads";
import RedditThumb2Ads from "../pages/Ads/RedditThumb2Ads";
import BlogPostAds from "../pages/Ads/BlogPostAds";
import EmailLargeAds from "../pages/Ads/EmailLargeAds";
import EmailSmallAds from "../pages/Ads/EmailSmallAds";
import SquareDevecoAds from "../pages/Ads/SquareDevecoAds";
import InstagramStoriesDevecoAds from "../pages/Ads/InstagramStoriesDevecoAds";
import InlineRectangleAds from "../pages/Ads/InlineRectangleAds";
import LargeRectangleAds from "../pages/Ads/LargeRectangleAds";
import BillboardAds from "../pages/Ads/BillboardAds";
import HalfPageAds from "../pages/Ads/HalfPageAds";
import WideSkyscraperAds from "../pages/Ads/WideSkyscraperAds";
import Leaderboard970Ads from "../pages/Ads/Leaderboard970Ads";
import Leaderboard728Ads from "../pages/Ads/Leaderboard728Ads";
import Leaderboard468Ads from "../pages/Ads/Leaderboard468Ads";
import GdnJapanAds from "../pages/Ads/GdnJapanAds";
import GdnResponsive1200x628Ads from "../pages/Ads/GdnResponsive1200x628Ads";
import GdnResponsive1200x1200Ads from "../pages/Ads/GdnResponsive1200x1200Ads";
import {
  KNOWN_TEMPLATES_BY_CHANNEL,
  RELEASES_OPT_IN_TEMPLATE_IDS,
  RELEASES_SET_TEMPLATE_IDS,
  TEMPLATES_BY_CHANNEL as CANONICAL_TEMPLATES_BY_CHANNEL,
  templateOffersProduct,
} from "./templateManifest";
import {drawnTemplates} from "./templateSlots";

const COMPONENTS_BY_KEY = {
  twitter: Twitter,
  "you-tube-community": YouTubeCommunity,
  "so-me-vertical": SoMeVertical,
  "instagram-stories": InstagramStories,
  "instagram-feed": InstagramFeed,
  "blog-featured": BlogFeatured,
  "blog-social-share": BlogSocialShare,
  "webpage-preview": WebpagePreview,
  splash: Splash,
  "splash-2-x": Splash2x,
  "splash-2026": Splash2026,
  "splash-2-x-2026": Splash2x2026,
  "releases-email-01": ReleasesEmail01,
  "releases-email-02": ReleasesEmail02,
  "releases-email-03": ReleasesEmail03,
  "releases-email-04": ReleasesEmail04,
  "horizontal-features": HorizontalFeatures,
  "whats-new-preview": WhatsNewPreview,
  "wallpaper-1": Wallpaper1,
  "wallpaper-2": Wallpaper2,
  "wallpaper-3": Wallpaper3,
  "wallpaper-preview": WallpaperPreview,
  "dot-net-splash": DotNetSplash,
  "dot-net-splash-2-x": DotNetSplash2x,
  "dot-net-splash-legacy": DotNetSplashLegacy,
  "dot-net-splash-2-x-legacy": DotNetSplash2xLegacy,
  screenshot: Screenshot,
  "demo-video-intro": DemoVideoIntro,
  "demo-video-intro-demo": DemoVideoIntroDemo,
  "demo-video-demo": DemoVideoDemo,
  "demo-video-code": DemoVideoCode,
  "livestream-horizontal": LivestreamHorizontal,
  "livestream-square": LivestreamSquare,
  "livestream-blog": LivestreamBlog,
  "livestream-wide": LivestreamWide,
  "livestream-stories-intro": LivestreamStoriesIntro,
  "livestream-stories": LivestreamStories,
  "livestream-email": LivestreamEmail,
  "blog-social-share-internal": BlogSocialShareInternal,
  "email-01": Email01,
  "email-02": Email02,
  "email-03": Email03,
  "email-04": Email04,
  voucher: Voucher,
  "landing-page": LandingPage,
  "twitter-partners": TwitterPartners,
  "instagram-stories-partners": InstagramStoriesPartners,
  "instagram-post-partners": InstagramPostPartners,
  "instagram-feed-partners": InstagramFeedPartners,
  "so-me-vertical-partners": SoMeVerticalPartners,
  "you-tube-thumbnail": YouTubeThumbnail,
  "you-tube-first-slide-webinar": YouTubeFirstSlideWebinar,
  "you-tube-thumbnail-webinar": YouTubeThumbnailWebinar,
  "blog-featured-webinar": BlogFeaturedWebinar,
  "blog-social-share-webinar": BlogSocialShareWebinar,
  "horizontal-webinar": HorizontalWebinar,
  "stream-yard-webinar": StreamYardWebinar,
  "stream-yard-background-webinar": StreamYardBackgroundWebinar,
  "email-photo-webinar": EmailPhotoWebinar,
  "speaker-photo-webinar": SpeakerPhotoWebinar,
  "qrcode-ipad": QRcodeIPad,
  "qrcode-full-hd": QRcodeFullHD,
  "qrcode-a-4": QRcodeA4,
  "qrcode-print": QRcodePrint,
  "so-me-horizontal-ads": SoMeHorizontalAds,
  "instagram-post-ads": InstagramPostAds,
  "instagram-stories-ads": InstagramStoriesAds,
  "reddit-ads": RedditAds,
  "daily-dev-ads": DailyDevAds,
  "reddit-thumb-1-ads": RedditThumb1Ads,
  "reddit-thumb-2-ads": RedditThumb2Ads,
  "blog-post-ads": BlogPostAds,
  "email-large-ads": EmailLargeAds,
  "email-small-ads": EmailSmallAds,
  "square-deveco-ads": SquareDevecoAds,
  "instagram-stories-deveco-ads": InstagramStoriesDevecoAds,
  "inline-rectangle-ads": InlineRectangleAds,
  "large-rectangle-ads": LargeRectangleAds,
  "billboard-ads": BillboardAds,
  "half-page-ads": HalfPageAds,
  "wide-skyscraper-ads": WideSkyscraperAds,
  "leaderboard-970-ads": Leaderboard970Ads,
  "leaderboard-728-ads": Leaderboard728Ads,
  "leaderboard-468-ads": Leaderboard468Ads,
  "gdn-japan-ads": GdnJapanAds,
  "gdn-responsive-1200-x-628-ads": GdnResponsive1200x628Ads,
  "gdn-responsive-1200-x-1200-ads": GdnResponsive1200x1200Ads,
};

const buildClientTemplate = (metadata) => {
  const Component = COMPONENTS_BY_KEY[metadata.key];
  if (!Component) {
    throw new Error(`Template "${metadata.key}" has no client component`);
  }
  return {
    ...metadata,
    getComponent() {
      const id = this.id;
      if (typeof id !== "string" || id.length === 0) {
        throw new Error(`Template "${metadata.key}" has no render ID`);
      }
      return (
        <TemplateScope templateId={metadata.id} id={id} width={metadata.width} height={metadata.height} zoom={this.zoom}>
          <Component id={id} zoom={this.zoom} />
        </TemplateScope>
      );
    },
  };
};

/**
 * Every design of every channel with its component, on air or not, in channel
 * order. A saved scene and a preview can draw a design that is not on air.
 */
export const knownTemplates = Object.fromEntries(
  Object.entries(KNOWN_TEMPLATES_BY_CHANNEL).map(([channel, entries]) => [
    channel,
    entries.map(buildClientTemplate),
  ])
);

const KNOWN_BY_CHANNEL_AND_KEY = new Map(
  Object.entries(knownTemplates).flatMap(([channel, entries]) =>
    entries.map((template) => [`${channel}/${template.key}`, template])
  )
);

function clientTemplate(channel, key) {
  const template = KNOWN_BY_CHANNEL_AND_KEY.get(`${channel}/${key}`);
  if (!template) throw new Error(`Template "${key}" is not in channel "${channel}"`);
  return template;
}

/**
 * The designs that code puts on air, one per slot. A page follows the live
 * choice or its saved scene instead: drawnClientTemplates.
 */
export const templates = Object.fromEntries(
  Object.entries(CANONICAL_TEMPLATES_BY_CHANNEL).map(([channel, entries]) => [
    channel,
    entries.map((entry) => clientTemplate(channel, entry.key)),
  ])
);

function filterByProduct(channel, list, product) {
  if (!list) throw new Error(`Unknown channel "${channel}"`);
  if (typeof product !== "string" || product.length === 0) {
    throw new Error(`Templates of "${channel}" need a product`);
  }
  return list.filter((template) => templateOffersProduct(template, product));
}

/**
 * The client templates a channel draws under a template selection
 * (data/templateSlots.ts): one per slot, in channel order.
 */
export function drawnClientTemplates(channel, selection) {
  if (!selection) throw new Error(`Templates of "${channel}" need a template selection`);
  return drawnTemplates(channel, selection).map((entry) => clientTemplate(channel, entry.key));
}

/**
 * The client templates a channel draws for a product under a template
 * selection: one per id. A channel can list two templates under one id for
 * different products (templateManifest.ts), so a list keyed by id reads this.
 */
export function drawnTemplatesFor(channel, product, selection) {
  return filterByProduct(channel, drawnClientTemplates(channel, selection), product);
}

/** The designs that code puts on air in a channel for a product: one per id. */
export function templatesFor(channel, product) {
  return filterByProduct(channel, templates[channel], product);
}

/** Every design of a channel that a product sees, on air or not. */
export function knownTemplatesFor(channel, product) {
  return filterByProduct(channel, knownTemplates[channel], product);
}

export {RELEASES_OPT_IN_TEMPLATE_IDS, RELEASES_SET_TEMPLATE_IDS};
